import React, { useEffect } from 'react';

import { CommonHead } from '@app/components/CommonHead';
import { Footer } from '@app/components/Footer';
import Header from '@app/components/home/Header';
import ScreenType from '@app/components/ui/ScreenType';

interface DefaultLayoutProps {
  children: React.ReactNode;
}

const DefaultLayout: React.FC<DefaultLayoutProps> = ({ children }) => {
  return (
    <>
      <CommonHead />

      <div className="min-h-screen bg-white flex flex-col text-gray-900">
        <ScreenType />
        <Header />

        {/* Main Content */}
        <main className="flex flex-col grow-1 gap-15 mb-15">{children}</main>

        <Footer />
      </div>
    </>
  );
};

export default DefaultLayout;
